import { getConfig } from '@/api/server';
import i18n from '@/i18n';
import { useCommonStore } from '@/stores/common';
import { useConfigStore } from '@/stores/config';
import { posToLocaleLanguage } from '@/utils';
import Admin from '@/views/Admin.vue';
import { createRouter, createWebHistory } from 'vue-router';

const Auth = () => import('@/views/Auth.vue');
const Login = () => import('@/views/Login.vue');
const Home = () => import('@/views/Home.vue');

const routes = [
  { path: '/', component: Auth, name: 'Auth', meta: { skipConfigFetch: true } },
  { path: '/login', component: Login, name: 'Login', meta: { skipConfigFetch: true } },
  { path: '/home', component: Home, name: 'Home', meta: { layout: 'Main' } },
  { path: '/home/:StoreID/:SubStoreCode', name: 'MobileHome', component: Home, meta: { layout: 'Main' } },
  { path: '/admin', component: Admin, name: 'Admin' }, // 관리자 페이지 처음 접속 시 반응 속도를 위해 동적 라우팅 사용안함
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.beforeEach(async (to, _, next) => {
  const commonStore = useCommonStore();
  const configStore = useConfigStore();

  if (to.name === 'MobileHome') {
    /**
     * URL에 매장 아이디가 세팅되어 있다면 모바일 메뉴판으로 판단하여 기본 설정 값 적용
     * 그 외에는 기본 인증 로직 적용
     */
    if (to.params.StoreID) {
      // 모바일 접속 설정
      configStore.setIsMobileMenu(true);

      // 모바일 접속인 경우 대기 팝업 타임아웃 해제
      commonStore.clearWaitingPopupInterval();
      // 모바일 접속인 경우 실시간 데이터 업데이트 인터벌 해제
      commonStore.clearRealtimeUpdateInterval();

      const localConfig = configStore.localConfig;
      localConfig.StoreID = to.params.StoreID.toString();
      localConfig.SubStoreCode = to.params.SubStoreCode.toString();
      configStore.setLocalConfig(localConfig);
    }
  }

  // 로그인페이지를 제외하고 설정이 조회되어 있지 않다면 설정 조회
  if (!to.meta.skipConfigFetch && !configStore.serverConfig) {
    const serverConfig = await getConfig();
    configStore.setServerConfig(serverConfig);
    i18n.global.locale.value = posToLocaleLanguage(serverConfig.PosLanguage);
  }

  if (to.name === 'Home') {
    // 대기 화면 팝업 타임아웃 시작
    commonStore.setWaitingPopupInterval();
  }

  next();
});

export default router;
